import { WithMenu } from '../hocs'
import UnwrappedButton from './unwrapped'

import './styles.scss'

export default WithMenu(UnwrappedButton, {
  bodyAttached: true,
  closeOnSelect: true,
  popoverOptions: {
    hasCaret: false,
    align: 'start',
  },
})

export { UnwrappedButton }
